import MajorBannerPage from './MajorBannerPage'
export default MajorBannerPage